import React from 'react';
import { GetBrandedAppName } from '../../../services/BrandingService';
import VoicePicker from '../../VoicePicker';

export default class StoryPicker extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      options: [],
      buttonsDisabled: true,
      loading: false,
    };

    this.selectStory = this.selectStory.bind(this);
  }

  componentDidMount(){
    document.title = `Select a Story - ${GetBrandedAppName()}`;

    this.readChoices();

    let options = this.props.recommendedStories.map((story)=>{
      let newStory = story;
      newStory.name = story.title;
      return newStory;
    });
    this.setState({
      options: options,
    });
  }

  readChoices(){
    let props = {};

    let onStart= (
      function(event){
        this.setState({
          buttonsDisabled: false,
        });
      }
    ).bind(this);

    this.props.speakChooseStoryMessage(this.props.speech, this.props.recommendedStories, null, onStart, true);
  }
  
  selectStory(story){
    this.setState({
      loading: true,
    });
    this.props.speech.abortSpeech(()=>{
      this.props.setStory(story.storyid);
    });
  }

  render() {
    return (
      <VoicePicker
        options={this.state.options}
        speech={this.props.speech}
        title={this.props.title}
        prompt="I'm sorry, I didn't understand that. Please say the title of the story you want to read."
        selectOption={this.selectStory}
        close={this.props.close}
        buttonsDisabled={this.state.buttonsDisabled}
        loading={this.state.loading}
      />
    );
  }
}
